<template>
    <div id="childBuyhand" class="page-content">
        <!-- 退货 -->
        <el-dialog :title="title" :visible.sync="open" width="620px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="150px"
                style="height: 500px;overflow: auto;margin-top: 20px;" v-if="buytype != 'R买'">
                <el-row>
                    <el-col :span="24" v-if="title == '买手结算详情'">
                        <el-form-item label="结算ID">
                            {{ form.buyernumber }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="订单编号" prop="orderidList">
                            <el-select v-model="form.orderidList" multiple clearable placeholder="请选择订单编号"
                                style="width: 410px;" size="small" @change="seletChange">
                                <el-option v-for="item in options" :key="item.orderid" :label="item.ordernumber"
                                    :value="item.orderid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="结算支付日期" prop="buyerdate">
                            <el-date-picker v-model="form.buyerdate" value-format="yyyy-MM-dd" type="date"
                                placeholder="请选择结算支付日期" style="width: 410px;" size="small"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="买手佣金支付截图" prop="buyerscreenshot">
                            <el-upload class="upload-demo" action="/hcm/hcmWorkOrder/headImgUploadOrder"
                                :show-file-list="false" :before-upload="handleBeforeUpload"
                                :on-success="handleUploadSuccess" accept="image/png, image/jpg" :multiple="true"
                                :ref="elUpload">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                            <div v-for="(image, index) in buyerscreenshot" :key="index"
                                style="float: left;margin: 10px 10px 0px 0px;position: relative;">
                                <img :src="image" class="avatar" style="width: 100px; height: 100px;font-size: 20px;" />
                                <i class="el-icon-error"
                                    style="position: absolute;right: 10px;top: 10px;cursor: pointer;"
                                    @click="delIcon(index)"></i>
                            </div>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="买手佣金" prop="buyerprice">
                            <el-input v-model="form.buyerprice" clearable placeholder="请填写买手佣金" style="width: 410px;"
                                size="small" type="number" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="24" v-if="title == '买手结算详情'">
                        <el-form-item label="创建时间">
                            {{ form.createtime | fullTime }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '买手结算详情'">
                        <el-form-item label="创建人">
                            {{ form.createuser }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '买手结算详情'">
                        <el-form-item label="更新时间" v-if="form.updatetime">
                            {{ form.updatetime | fullTime }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '买手结算详情'">
                        <el-form-item label="更新人" v-if="form.updateuser">
                            {{ form.updateuser }}
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel(2)">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    name: "childBuyhand",
    props: {
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            elUpload: true,
            elUpload: true,
            title: '',
            form: {
                orderidList: [],
            },
            rules: {
                orderidList: [
                    { required: true, message: '请选择订单编号', trigger: 'blur' },
                ],
                buyerdate: [
                    { required: true, message: '请选择结算支付日期', trigger: 'blur' },
                ],
                buyerscreenshot: [
                    { required: true, message: '请选择买手佣金支付截图', trigger: 'blur' },
                ],
                buyerprice: [
                    { required: true, message: '请填写买手佣金', trigger: 'blur' },
                ]
            },
            open: false,
            returnList: [],
            dynamicRules: this.rules,
            buytype: '',
            options: [],
            dianjiIndex: 0,
            optionTitle: '',
            buyerscreenshot: [],
        };
    },
    created() {

    },
    methods: {
        delIcon(index) {
            this.buyerscreenshot.splice(index, 1)
        },
        seletChange() {
            this.$forceUpdate();
        },
        updateChange(data) {
            this.form = {};
            this.title = data.title;
            console.log(data,'datadatadata')
            if (data.form && data.form.buyerscreenshot) {
                this.buyerscreenshot = data.form.buyerscreenshot.split(',');
            }
            this.OrderChange(data);
        },
        // 获取订单编号
        OrderChange(data) {
            let params = {}
            fetch({
                url: "hcm/hcmOrdergoods/getListOrderNumber",
                method: "get",
                noFormat: true,
                params: params,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.options = [];
                    if (result.data.length > 0) {
                        for (let a in result.data) {
                            let shouldAdd = false;
                            for (let b in data.list) {
                                if ((result.data[a].status != 1 || result.data[a].ordernumber == data.list[b]) && !shouldAdd) {
                                    let alreadyExists = this.options.some(option => option.orderid === result.data[a].orderid);
                                    if (!alreadyExists) {
                                        this.options.push(result.data[a]);
                                        shouldAdd = true; // 确保每个元素只被添加一次
                                    }
                                }
                            }
                        }
                    }
                    this.form = data.form;
                    if (this.form.buyerdate) {
                        this.form.buyerdate = this.$options.filters.fullTime(this.form.buyerdate);
                    }

                    if (data && data.list) {
                        this.form.orderidList = [];
                        for (let a in data.list) {
                            for (let b in this.options) {
                                if (this.options[b].ordernumber == data.list[a]) {
                                    this.form.orderidList.push(this.options[b].orderid);
                                }
                            }
                        }
                    }
                    this.$forceUpdate();
                    this.open = true;
                }
            })
        },
        // 图片上传前判断
        handleBeforeUpload(file) {
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                this.$message.error('上传文件大小不能超过 20MB!');
            }
            return isLt20M;
        },
        handleUploadSuccess(res) {
            this.buyerscreenshot.push(res.data.data);
            this.form.buyerscreenshot = ''
            this.form.buyerscreenshot = this.buyerscreenshot.join(',');
            this.elUpload = false;
        },
        // 提交
        submitForm() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    fetch({
                        url: "hcm/hcmOrderbuyer/saveOrderbuyer",
                        method: "post",
                        data: JSON.stringify(this.form),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        noFormat: false,
                        responseType: "json"
                    }).then((res) => {
                        if (res.status === '10000') {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            })
                            this.open = false;
                        } else {
                            this.$message.error(res.message);
                        }
                    }).catch(err => {
                        this.$message.error('服务器出错');
                    });
                    this.$emit('call-parent-method');
                }
            });
            // }
        },
        cancel() {
            this.open = false;
        },
    }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 50px;
    width: 50px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

#childBuyhand {
    .el-table th {
        background-color: #f3f7ff !important;
    }

    .el-table__empty-text {
        padding-top: 100px;
        background: url("../../../assets/img/other/nodata.svg") no-repeat;
        background-position: center 66px;
    }

    .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #d9d9d9;
    }

    .el-table thead {
        color: #333333;
        font-weight: 500;
    }

    .el-button+.el-button {
        margin-left: 0px;
    }

    .bottom_page .el-pagination {
        text-align: right;
        margin-top: 0px;
        padding-bottom: 0px;
    }
}
</style>